export default {
    parts: [
        'page',
        'container',
        'grid',
        'summaryColumn',
        'summaryColumnInner',
        'formStack',
        'desktopPlaceOrder',
        'stickyFooter',
        'stickyFooterContainer',
        'mobileSummaryBox',
        'storePickupModalContent',
        'storePickupModalBody'
    ],
    baseStyle: {
        page: {
            flex: '1'
        },
        container: {
            maxWidth: '926px',
            p: 0
        },
        grid: {
            gridTemplateColumns: {base: 'minmax(0, 1fr)', lg: 'minmax(0, 1fr) 343px'},
            gap: {base: 0, lg: '125px'}
        },
        summaryColumn: {
            px: [4, 4, 4, 0]
        },
        summaryColumnInner: {
            display: {base: 'none', lg: 'block'},
            position: {base: 'static', lg: 'sticky'},
            top: {base: '0', lg: '107px'},
            alignSelf: 'flex-start'
        },
        formStack: {
            spacing: 0,
            px: {base: 4, lg: 0}
        },
        desktopPlaceOrder: {
            display: {base: 'none', lg: 'block'},
            pt: 2
        },
        stickyFooter: {
            display: {lg: 'none'},
            position: 'fixed',
            bottom: '0',
            left: '0',
            right: '0',
            zIndex: 'banner',
            p: 4,
            background: 'white',
            borderTop: '1px solid',
            borderColor: 'webTheme.strokeTertiary'
        },
        stickyFooterContainer: {
            variant: 'form'
        },
        mobileSummaryBox: {
            display: {base: 'block', lg: 'none'},
            px: 4,
            pb: 6,
            mt: 12
        },
        storePickupModalContent: {
            borderRadius: '0',
            height: {base: '100%', lg: 'auto'},
            margin: {base: 0, lg: 'auto'}
        },
        storePickupModalBody: {
            margin: 'auto',
            py: 16
        }
    }
}
